module.exports = __webpack_public_path__ + "static/media/Create_discount_codes3.a44f2c3e.svg";